import io from 'socket.io-client';

let socket = null;

export const getSocketUrl = () =>
  process.env.REACT_APP_SOCKET_URL ||
  (window.location.port === '3000'
    ? `${window.location.protocol}//${window.location.hostname}:3001`
    : window.location.origin);

export const getSocket = () => {
  if (!socket) {
    socket = io(getSocketUrl(), {
      transports: ['websocket', 'polling'],
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 500,
      reconnectionDelayMax: 5000,
      timeout: 20000
    });
  }
  if (socket.disconnected) socket.connect();
  return socket;
};
